<template>
  <b-modal
    size="lg"
    title="Selekcja wieloatrybutowa"
    v-model="showModal"
    @hide="close"
  >
    <p>
      Czy na pewno chcesz dokonać zmiany
      {{ selectedVisibleItems.length - 1 || 0 }} obiektów w ramach selekcji
      wieloatrybutowej?
    </p>
    <br />
    <!--To do save my choice -->
    <!-- <b-form-row
      ><b-col md="8">Zapamiętaj mój wybór</b-col
      ><b-col md="4">
        <b-form-checkbox
          v-model.lazy="tempSettings.multiselectModification.notification"
          :checked="!tempSettings.multiselectModification.notification"
        ></b-form-checkbox></b-col
    ></b-form-row> -->
    <div slot="modal-footer" class="w-100">
      <b-btn
        class="float-right ml-2"
        variant="primary"
        @click="modifyMultiselectItems()"
        >Tak</b-btn
      >
      <b-btn
        class="float-right ml-2"
        variant="outline-secondary"
        @click="close()"
        >Nie</b-btn
      >
    </div>
    <loading-overlay
      :active.sync="this.isLoading"
      :is-full-page="true"
    ></loading-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import LoadingOverlay from 'vue-loading-overlay';

import {
  EDIT_SESSION_APPLY_MULTISELECT_MODIFICATATION,
  EDIT_SESSION_UPDATE_SETTINGS
} from '../../store/actions.type';

export default {
  name: 'MultiselectModificationModal',
  components: { LoadingOverlay },
  props: {
    showMultiselectModificationModal: false,
    multiselectModificationData: null
  },

  computed: {
    ...mapGetters(['features', 'manualImportSettings']),
    selectedVisibleItems() {
      return this.features.filter(feature => {
        return feature.selected && feature.visible;
      });
    }
  },

  watch: {
    showMultiselectModificationModal: function(newVal) {
      this.showModal = newVal;
    },
    showModal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.setStartTempSettings();
        }
      }
    },
    manualImportSettings: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.saveSettingsToLocalStorage();
        }
      }
    }
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      tempSettings: {}
    };
  },
  methods: {
    close() {
      // this.saveConfig();
      this.$emit('close');
    },
    modifyMultiselectItems() {
      this.isLoading = true;
      this.applyMultiselectModification();
      this.isLoading = false;
      this.close();
    },
    async applyMultiselectModification() {
      await this.$store.dispatch(
        EDIT_SESSION_APPLY_MULTISELECT_MODIFICATATION,
        this.multiselectModificationData
      );
    },
    setStartTempSettings() {
      this.tempSettings = JSON.parse(JSON.stringify(this.manualImportSettings));
    },
    saveConfig() {
      this.$store.commit(
        EDIT_SESSION_UPDATE_SETTINGS,
        JSON.parse(JSON.stringify(this.tempSettings))
      );
    },
    saveSettingsToLocalStorage() {
      localStorage.setItem(
        'manualImportSettings',
        JSON.stringify(this.manualImportSettings)
      );
    }
  },
  mounted() {
    this.setStartTempSettings();
  }
};
</script>
<style></style>
